import Loading from '@/common/components/Loading';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import useQueueLeadsGuessingReport from './hooks/useQueueLeadsGuessingReport';
import { getQueueGuessingRows } from './helpers/getQueueGuessingRows';
import Table from '@/common/components/Table';
import SearchBox from './components/SearchBox';

const COLUMNS = [
	'No',
	'Creation Date',
	'Queue',
	'T2 Fresh',
	'Min Left',
	'Target Dequeue Count ( including point )',
	'Leads Result',
	'Leads Result Date',
	'Next Leads Result',
	'Next Leads Result Date',
];

const QueueLeadsGuessingReport = () => {
	const hook = useQueueLeadsGuessingReport();

	return (
		<>
			{hook.isLoading && <Loading nBest={hook.calculation} />}
			<WrapperWithScroll>
				<SearchBox hook={hook} />
				{hook?.data && (
					<Table
						className='styled-table'
						raws={getQueueGuessingRows(hook.data)}
						headers={COLUMNS}
					/>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default QueueLeadsGuessingReport;
